export default __webpack_public_path__ + "static/media/kidzone.08619f67c99dedd4758a03cbd723bca1.svg";